<template>
  <i
    class="tm-audio-span"
    @mouseenter="$_toggleHover"
    @mouseleave="$_toggleHover"
  >
    <i class="tm-audio-material" :style="styleObj" :title="fileName" />

    <tm-audio-wave
      :style="styleObj"
      :track="$props.track"
      :rectangle="$props.rectangle"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :isSelected="$props.isSelected"
      :isMoving="$props.track.isMoving"
      :hasAudioWaveForm="$props.hasAudioWaveForm"
    />

    <tm-audio-text
      :style="styleObj"
      :track="$props.track"
      :rectangle="$props.rectangle"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :audioTranscript="$props.audioTranscript"
      :isSelected="$props.isSelected"
      :isHovered="$props.isHovered"
      :isMoving="$props.track.isMoving"
    />

    <tm-audio-border
      :style="styleObj"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :showDim="showDim"
      :isSelected="$props.isSelected"
    />
  </i>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import tmAudioBorder from 'v/Story/Timeline/view/track/audio/tmAudioBorder.vue';
import tmAudioWave from 'v/Story/Timeline/view/track/audio/tmAudioWave.vue';
import tmAudioText from 'v/Story/Timeline/view/track/audio/tmAudioText.vue';

export default {
  name: 'tm-audio-span',
  components: {
    tmAudioText,
    tmAudioWave,
    tmAudioBorder,
  },

  props: {
    track: { type: Object, required: true },
    audioTranscript: { type: Object, required: false, default: null },
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    isSelected: { type: Boolean, required: true },
    isHovered: { type: Boolean, required: true },
    hasAudioWaveForm: { type: Boolean, required: true },
  },

  computed: {
    ...mapGetters('timemachine', ['isDndMode']),
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      trackInHand: (state) => state.dndEscort.trackInHand,
      pxAudioTopOffset: (state) => state.cssVariables.pxAudioTopOffset,
      pxAudioTrackH: (state) => state.cssVariables.pxAudioTrackH,
    }),

    styleObj() {
      return {
        transform: `translate3d(${this.$props.rectangle.p1.x}px, ${
          this.$props.rectangle.p1.y + this.pxAudioTopOffset
        }px, 0)`,
        width: `${this.$props.rectangle.width}px`,
        height: `${this.pxAudioTrackH}px`,
      };
    },

    isDragging() {
      return this.trackInHand?.guid === this.$props.track.guid;
    },

    showDim() {
      return this.isDndMode
        ? this.isDragging
        : !this.MODE_SCENE_EDIT && this.$props.isHovered;
    },

    fileName() {
      return this.$props.track.data.metadata.title;
    },
  },

  methods: {
    $_toggleHover(e) {
      this.$emit('hovered', e.type === 'mouseenter', this.$props.rectangle);
    },
  },
};
</script>

<style lang="scss">
.tm-audio > .tm-audio-span {
  .tm-audio-material {
    position: absolute;
    background-color: white;

    &.-dim:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
